import { jsx as _jsx } from "react/jsx-runtime";
import ProfilePage from "@/views/profile";
import { RoutesList } from "../routesList";
/** Роуты для профиля пользователя */
export var routesProfile = [
    {
        path: RoutesList.Profile.getUserProfile(),
        element: _jsx(ProfilePage, {}),
    },
];
